import { ArrowRight, Mail } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function CTASection() {
  return (
    <section className="relative overflow-hidden bg-[#EDF5F2] py-24 md:py-28">
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(rgba(0,38,28,0.035)_1px,transparent_1px),linear-gradient(90deg,rgba(0,38,28,0.035)_1px,transparent_1px)] bg-[size:48px_48px]" />
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <p className="font-mono text-xs uppercase tracking-[0.18em] text-[#315f50]">
            Next step
          </p>
          <h2 className="mt-4 font-display text-4xl font-bold leading-tight text-[#00261C] sm:text-5xl">
            Choose how you want to work.
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-[#00261C]/68">
            Run a defined check yourself, or bring us a complex trade problem to investigate.
          </p>

          <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
            <Button
              asChild
              size="lg"
              className="h-auto border-none bg-[#00261C] px-8 py-6 text-base font-semibold text-[#B2F273] hover:bg-[#00382E]"
            >
              <Link to="/#self-serve">
                Run a self-serve check
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="h-auto border-[#00261C]/25 bg-transparent px-8 py-6 text-base text-[#00261C] hover:bg-[#00261C] hover:text-[#B2F273]"
            >
              <Link to="/contact">Discuss a managed engagement</Link>
            </Button>
          </div>

          <p className="mt-10 flex items-center justify-center gap-2 text-sm text-[#00261C]/55">
            <Mail className="h-4 w-4" />
            <a href="mailto:hello@trdrhub.com" className="font-semibold underline hover:no-underline">
              hello@trdrhub.com
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
